import React from 'react';
import { Flag } from 'lucide-react';
import { CATEGORY_LABELS, categoryBg } from '../copy';

// The score out of 100. Accepts both shapes the platform saves: the
// assessment result (overall_score 0..1) and the scorecard summary
// (score 0..1).
export function readinessScore(data) {
  const raw = data.overall_score ?? data.score ?? 0;
  return Math.round((raw > 1 ? raw : raw * 100));
}

export default function ReadinessBody({ artifact, data }) {
  const score = readinessScore(data);
  const categories = Object.entries(data.category_scores || {});
  const tier = String(data.tier || '').replace(/_/g, ' ');
  return (
    <div className="flex flex-wrap items-start gap-7">
      <div className="flex flex-col gap-1.5 min-w-[150px]">
        <div className="flex items-baseline gap-1.5 tabular-nums">
          <span className="text-[56px] font-light tracking-[-0.03em] leading-none text-orange-ink">{score}</span>
          <span className="text-[24px] font-light text-muted-foreground">/ 100</span>
        </div>
        {tier && (
          <span className="self-start font-label text-[10px] tracking-[0.06em] uppercase py-[3px] px-[9px] rounded-full bg-succeedo-orange/10 border border-succeedo-orange/20 text-orange-ink">
            {tier}
          </span>
        )}
        {artifact.summary && <span className="text-[13px] text-muted-foreground max-w-[190px]">{artifact.summary}</span>}
      </div>
      <div className="flex flex-col flex-1 min-w-[240px] gap-3">
        {categories.map(([name, value]) => {
          const v = Math.round(Number(value) * 100);
          const flagged = (data.red_flag_categories || []).includes(name);
          return (
            <div key={name} className="flex flex-col gap-1.5">
              <div className="flex justify-between items-center text-[13px]">
                <span className="inline-flex items-center gap-2">
                  {CATEGORY_LABELS[name] || name}
                  {flagged && (
                    <span className="inline-flex items-center gap-1 font-label text-[10px] uppercase text-coral-ink">
                      <Flag size={11} /> Red flag
                    </span>
                  )}
                </span>
                <span className="tabular-nums text-muted-foreground">{v}</span>
              </div>
              <div className="h-1.5 rounded-full bg-border overflow-hidden">
                <div className={`h-full rounded-full ${categoryBg(name)}`} style={{ width: `${v}%` }} />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
